import React, { useState, useEffect, useCallback } from 'react';
import http from '../http';
import C from '../colors';

function CaptchaInput({ captchaID, setCaptchaID, captcha, setCaptcha, placeholder, error, helperText, onChange }) {
  const [captchaSvg, setCaptchaSvg] = useState('');
  const [captchaRight, setCaptchaRight] = useState(false);
  const [focused, setFocused] = useState(false);

  const fetchCaptcha = useCallback(async () => {
    try {
      const res = await http.get('/captcha');
      setCaptchaID(res.data.captchaID);
      setCaptchaSvg(res.data.captchaImage);
      setCaptchaRight(false);
    } catch {}
  }, [setCaptchaID]);

  useEffect(() => { fetchCaptcha(); }, [fetchCaptcha]);

  const checkCaptcha = async (val) => {
    try {
      const res = await http.post('/captcha', { captchaID, captcha: val });
      return res.data;
    } catch {}
  };

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 6 }}>
        <div style={{ flex: 1, position: 'relative' }}>
          <input
            value={captcha} placeholder={placeholder}
            name="captcha"
            onFocus={() => setFocused(true)} onBlur={() => setFocused(false)}
            onChange={async (e) => {
              const val = e.target.value;
              setCaptcha(val);
              onChange?.(e);
              if (val.length < 4) return;
              const r = await checkCaptcha(val);
              if (r?.success) setCaptchaRight(true);
            }}
            style={{
              width: '100%', boxSizing: 'border-box',
              padding: '9px 38px 9px 12px', borderRadius: 9, outline: 'none',
              border: `1.5px solid ${error ? '#e88c7c' : focused ? C.brand : C.hair}`,
              fontFamily: C.sans, fontSize: 14, background: '#fff',
            }}
          />
          <button type="button" onClick={fetchCaptcha} style={{ position: 'absolute', right: 6, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: C.ink3, display: 'grid', placeItems: 'center' }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/></svg>
          </button>
        </div>
        {captchaRight
          ? <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={C.successFg} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/></svg>
          : captcha.length === 4
            ? <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={C.dangerFg} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="m15 9-6 6M9 9l6 6"/></svg>
            : null}
        <div dangerouslySetInnerHTML={{ __html: captchaSvg }} style={{ flexShrink: 0 }}/>
      </div>
      {error && helperText && <div style={{ fontSize: 11.5, color: '#c2412e', marginTop: 4 }}>{helperText}</div>}
    </div>
  );
}
export default CaptchaInput;
